import { useQuery } from '@tanstack/react-query';
import { 
  getTransactionSummary, 
  getUserSummary, 
  getCardSummary,
  TransactionSummaryResponse,
  UserSummaryResponse,
  CardSummaryResponse
} from '../services/analyticsService';

export const useTransactionSummary = () => {
  return useQuery<TransactionSummaryResponse>({
    queryKey: ['analytics', 'transaction-summary'],
    queryFn: getTransactionSummary,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};

export const useUserSummary = () => {
  return useQuery<UserSummaryResponse>({
    queryKey: ['analytics', 'user-summary'],
    queryFn: getUserSummary,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};

export const useCardSummary = () => {
  return useQuery<CardSummaryResponse>({
    queryKey: ['analytics', 'card-summary'],
    queryFn: getCardSummary,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
